import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=0606c0bf&scoped=true&"
import script from "./MenuNavigation.vue?vue&type=script&lang=js&"
export * from "./MenuNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=0606c0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606c0bf",
  null
  
)

export default component.exports